/**
 * Interaction tracking utility — Phase 2: For You recommendation engine.
 *
 * All calls are fire-and-forget. Errors are silently swallowed so tracking
 * never affects the user experience.
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Track a user interaction event.
 *
 * @param {string} type - 'search' | 'view' | 'click' | 'dwell' | 'message' | 'save'
 * @param {object} [payload] - Optional fields: item_id, query, category, subcategory, duration_ms
 */
export async function trackEvent(type, payload = {}) {
  const token = localStorage.getItem('token');
  if (!token) return; // Only track authenticated users

  try {
    await axios.post(
      `${API_URL}/api/tracking/event`,
      { type, ...payload },
      {
        headers: { Authorization: `Bearer ${token}` },
        // Short timeout — never block UI waiting for analytics
        timeout: 5000,
      }
    );
  } catch {
    // Silent fail — tracking must never surface errors to the user
  }
}
